import { Head, useForm } from "@inertiajs/react";

import AdminUserForm from "/components/Admin/AdminUserForm";

export default function AdminUsersEdit({
  admin_user
}) {
  const { data, setData, put, errors, transform } = useForm(admin_user);

  const handleSubmit = (e) => {
    e.preventDefault();

    put(`/admin/admin_users/${admin_user.id}`);
  };

  return (
    <>
      <Head>
        <title>Редактирование пользователя</title>
      </Head>

      <AdminUserForm
        data={data}
        setData={setData}
        onSubmit={handleSubmit}
        errors={errors}
      />
    </>
  );
}
